import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { v4 as uuid } from 'uuid';

import { clickDownloadLink } from '@/shared/features/file-preview/utils/download/download.utils';
import { TUseDownloadFile } from '@/shared/hooks/use-download-file/use-download-file.types';
import { showToastError } from '@/shared/utils/toast';

export const useDownloadFile = ({
  requestDownloadUrl,
  fileName,
  handleClose,
}: TUseDownloadFile = {}) => {
  const { t } = useTranslation();

  const handleClick = async (event: React.BaseSyntheticEvent) => {
    if (!requestDownloadUrl) {
      return;
    }

    const toastId = uuid();
    toast.loading(t('common:preparing_to_download'), { toastId });
    try {
      const downloadUrl = await requestDownloadUrl();
      if (!downloadUrl) {
        throw new Error('Missing download url');
      }

      clickDownloadLink(downloadUrl, fileName);
      toast.update(toastId, {
        render: t('common:download_success'),
        type: 'success',
        autoClose: 5000,
        isLoading: false,
      });
    } catch {
      toast.dismiss(toastId);
      showToastError(t('common:download_error'));
    }

    handleClose?.(event);
  };

  const downloadContent = (dataContent: string, contentFileName: string) => {
    const url = URL.createObjectURL(new Blob([dataContent]));
    clickDownloadLink(url, contentFileName);
    URL.revokeObjectURL(url);
  };

  return {
    handleClick,
    downloadContent,
    downloadUrl: clickDownloadLink,
  };
};
